import './dashboards-api.factory';
import './dashboards-requests.service';
import './dashboards-alerts.service';
import './dashboards-service.service';
import './dashboards-dialogs.service';
